import React, { useState } from 'react';
import accomodationData from '../data/accomodation';



const Accomodation = () => {
  const [location, setLocation] = useState('All');
  const [type, setType] = useState('All');
  const [search, setSearch] = useState('');
  const [showTypeDropdown, setShowTypeDropdown] = useState(false);

  // Get unique locations and types for filter dropdowns
  const locationOptions = ['All', ...Array.from(new Set(accomodationData.map(a => a.location)))];
  const typeOptions = ['All', ...Array.from(new Set(accomodationData.map(a => a.type)))];
  const businessNameOptions = Array.from(new Set(accomodationData.map(a => a.businessname)));

  // Filter logic
  let filteredAccomodation = accomodationData;
  if (location !== 'All') filteredAccomodation = filteredAccomodation.filter(a => a.location === location);
  if (type !== 'All') filteredAccomodation = filteredAccomodation.filter(a => a.type === type);
  if (search.trim() !== '') filteredAccomodation = filteredAccomodation.filter(a => a.type.toLowerCase().includes(search.trim().toLowerCase()) || a.businessname.toLowerCase().includes(search.trim().toLowerCase()));

  return (
    <div style={{ paddingLeft: 10 }}>
       {/* Header */}
      <header style={{ background: '#e8f5e9', color: '#388e3c', padding: '0.25rem', textAlign: 'center', borderRadius: 8, marginBottom: 2 }}>
        <h1 style={{ margin: 0, fontSize: '1.0rem', fontWeight: 700 }}>Accomodation: PGs, Hostels, Rooms </h1>
      </header>
      <div style={{ marginBottom: 0, display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        <div>
          <label htmlFor="location-select" style={{ fontWeight: 500, marginRight: 8 }}>Location:</label>
          <select
            id="location-select"
            value={location}
            onChange={e => setLocation(e.target.value)}
              style={{ padding: '0.18rem 0.35rem', borderRadius: 4, border: '1px solid #c5e1a5', fontSize: '0.95rem', minWidth: 50, height: '1.7rem', width: 95 }}
          >
            {locationOptions.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="type-select" style={{ fontWeight: 500, marginRight: 8 }}>Type:</label>
          <select
            id="type-select"
            value={type}
            onChange={e => setType(e.target.value)}
              style={{ padding: '0.18rem 0.35rem', borderRadius: 4, border: '1px solid #c5e1a5', fontSize: '0.95rem', minWidth: 50, height: '1.7rem', width: 95 }}
          >
            {typeOptions.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="accomodation-search" style={{ fontWeight: 500, marginRight: 8 }}>Search:</label>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                id="accomodation-search"
                type="text"
                value={search}
                onChange={e => setSearch(e.target.value)}
                onFocus={() => setShowTypeDropdown(true)}
                onBlur={() => setTimeout(() => setShowTypeDropdown(false), 150)}
                placeholder="Type business name..."
                  style={{ padding: '0.18rem 0.35rem', borderRadius: 4, border: '1px solid #c5e1a5', fontSize: '0.95rem', minWidth: 30, height: '1.7rem', width: 95 }}
              />
              <button
                type="button"
                onClick={() => setSearch('')}
                style={{
                  marginLeft: 4,
                  padding: '0.08rem 0.7rem',
                  borderRadius: 6,
                  border: 'none',
                  background: 'linear-gradient(90deg, #43e97b 0%, #38f9d7 100%)',
                  color: '#166534',
                  fontWeight: 700,
                  fontSize: '0.89rem',
                  cursor: 'pointer',
                  height: '1.3rem',
                  boxShadow: '0 2px 6px rgba(56, 249, 215, 0.10)',
                  transition: 'background 0.2s, color 0.2s',
                }}
                onMouseOver={e => { e.currentTarget.style.background = 'linear-gradient(90deg, #38f9d7 0%, #43e97b 100%)'; e.currentTarget.style.color = '#065f46'; }}
                onMouseOut={e => { e.currentTarget.style.background = 'linear-gradient(90deg, #43e97b 0%, #38f9d7 100%)'; e.currentTarget.style.color = '#166534'; }}
                >
                ✕ Clear
              </button>
            </div>
            {showTypeDropdown && (
              <div style={{ position: 'absolute', background: '#fff', border: '1px solid #c5e1a5', borderRadius: 4, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', marginTop: 2, zIndex: 10, minWidth: 100 }}>
                {businessNameOptions
                  .filter(name => search.trim() === '' || name.toLowerCase().includes(search.trim().toLowerCase()))
                  .slice(0, 8)
                  .map(businessname => (
                    <div
                      key={businessname}
                      style={{ padding: '0.2rem 0.5rem', cursor: 'pointer', fontSize: '0.85rem' }}
                      onMouseDown={() => { setSearch(businessname); setShowTypeDropdown(false); }}
                    >
                      {businessname}
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
  <p style={{ marginBottom: '1em', fontSize: '0.95rem' }}>Records listed: {filteredAccomodation.length}</p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.7rem' }}>
        {filteredAccomodation.map(item => (
          <div key={item.id} style={{ border: '1px solid #c5e1a5', borderRadius: '8px', padding: '1rem', width: '360px', background: '#f9fbe7', display: 'flex', alignItems: 'center', gap: '1rem', minHeight: 120, overflow: 'hidden', position: 'relative' }}>
            <img src={item.imagepath} alt={item.title} style={{ width: 130, height: 120, objectFit: 'cover', borderRadius: 8, flexShrink: 0 }} />
            <div style={{ flex: 1, overflowWrap: 'break-word', whiteSpace: 'normal', minWidth: 0 }}>
              <h3 style={{ margin: '0 0 0.3rem 0', color: '#388e3c', fontSize: '1rem', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{item.type}</h3>
              <div style={{ fontWeight: 'bold', fontSize: '1.08rem', marginBottom: 2, wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{item.businessname}</div>
              <div style={{ color: '#757575', fontSize: '0.95rem', marginBottom: 2, wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{item.location}, {item.areaname}</div>
              <div style={{ color: '#388e3c', fontSize: '0.95rem', marginBottom: 2, wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{item.price}</div>
              <div style={{ margin: '0.3rem 0', fontSize: '0.95rem', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>{item.description}</div>
                            <div style={{ color: '#1976d2', fontWeight: 500, fontSize: '0.95rem', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{item.contactperson}</div>
              <div style={{ color: '#1976d2', fontWeight: 500, fontSize: '0.95rem', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>
                <a href={`tel:${item.contactno.replace(/[^\d+]/g, '')}`} style={{ color: '#1976d2', textDecoration: 'none' }}>{item.contactno}</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Accomodation;
